import {
  Switch,
  Route
} from 'react-router-dom'
import './styles.scoped.sass'

import { SignIn } from './SignIn/SignIn'
import { SignUp } from './SignUp/SignUp'
import { RecoverPass } from './RecoverPass/RecoverPass'
import { SetNewPassword } from './SetNewPassword/SetNewPassword'
import getEnvironmentConfiguration from '@/config'
import { ReactComponent as BoxesLogoNegative } from '@/assets/svg/boxes-logo-negative.svg'
import { ReactComponent as BoxesLogo } from '@/assets/svg/boxes-logo.svg'
import { SideSection } from './components/side-section/SideSection'
import store from '@/core/store'
import { useEffect, useState } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'

function LoginPageConsumer (props) {
  // https://coolors.co/03045e-023e8a-0077b6-0096c7-00b4d8-48cae4-90e0ef-ade8f4-caf0f
  const { path } = props.match
  const [isOnboardingActive, setIsOnboardingActive] = useState(false)
  const config = getEnvironmentConfiguration()
  const [sideMenuHidden, setSideMenuHidden] = useState(false)
  const flags = useFlags()

  useEffect(() => {
    setIsOnboardingActive(flags.onboardingActiveClient)
  }, [flags])

  useEffect(() => {
    store.on('START_SIDE_MENU:VISIBILITY_ACK', (visibility) => {
      setTimeout(() => setSideMenuHidden(!visibility), 500)
    })
  }, [])

  return <div className="login-page">
    <div className="boxes-logo">
      { sideMenuHidden ? <BoxesLogoNegative/> : <BoxesLogo/>}
    </div>
    <SideSection match={props.match}/>
    <div className='right-side'>
      <div className="boxes-logo-mobile">
        <BoxesLogoNegative/>
      </div>
      <Switch>
        { (config.REACT_APP_IS_ONBOARDING_ENABLED || isOnboardingActive) && <Route path={`${path}/signup`} component={SignUp} /> }
        <Route path={`${path}/recover/set-password`}>
          <SetNewPassword />
        </Route>
        <Route path={`${path}/recover`}>
          <RecoverPass />
        </Route>
        <Route exact path={`${path}`}>
          <SignIn />
        </Route>
      </Switch>
    </div>
  </div>
}
export const LoginPage = LoginPageConsumer
